import { render } from "./ButtonCustom.vue?vue&type=template&id=6c9701d9"
import script from "./ButtonCustom.vue?vue&type=script&lang=js"
export * from "./ButtonCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__